import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkPolotnoType } from '@/pages/AdvancedEditor/utils';
import styled from '@emotion/styled';
import { CurrentValueControl } from './controls';

const ImageDetailsContainer = styled.div`
    padding: 20px;
    border: 1px solid ${({ theme }) => theme.colors.black[200]};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ImageDetails = () => {
    const { store } = useAdvancedEditorContext();
    const element = store.selectedElements[0];

    if (!checkPolotnoType(element, [polotnoTypes.Image, polotnoTypes.Svg])) {
        return null;
    }

    return (
        <ImageDetailsContainer>
            <CurrentValueControl />
        </ImageDetailsContainer>
    );
};
